export default __webpack_public_path__ + "static/media/update_complete.ad55d8ef.png";